import { IHomePartnerLogo } from './home-revamp-types';

export const HOME_NO_WALLET_ISOS: string[] = ['AF', 'IN'];
export const HOME_ROW_LAYOUT_ISOS: string[] = ['AF'];

const AFGHANISTAN_PARTNERS: IHomePartnerLogo[] = [
  { id: 'azizi-bank', file: 'azizi-bank.webp', alt: 'Azizi Bank' },
  { id: 'islamic-bank-of-afghanistan', file: 'islamic-bank-of-afghanistan.webp', alt: 'Islamic Bank of Afghanistan' },
  { id: 'osmani-exchange', file: 'osmani-exchange.webp', alt: 'Osmani Exchange' },
  { id: 'afghan-united-bank', file: 'afghan-united-bank.svg', alt: 'Afghan United Bank' }
];

const COLOMBIA_PARTNERS: IHomePartnerLogo[] = [
  { id: 'nequi', file: 'nequi.svg', alt: 'Nequi' },
  { id: 'bre-b', file: 'bre-b.svg', alt: 'Bre-B' },
  { id: 'bancolombia', file: 'bancolombia.svg', alt: 'Bancolombia', badge: true },
  { id: 'davivienda', file: 'davivienda.svg', alt: 'Davivienda', badge: true },
  { id: 'daviplata', file: 'daviplata.webp', alt: 'DaviPlata', badge: true },
  { id: 'exito', file: 'exito.svg', alt: 'Almacenes Éxito', badge: true },
  { id: 'banco-w', file: 'banco-w.svg', alt: 'Banco W', badge: true }
];

const INDIA_PARTNERS: IHomePartnerLogo[] = [
  { id: 'upi', file: 'upi.webp', alt: 'UPI' },
  { id: 'federal-bank', file: 'federal-bank.svg', alt: 'Federal Bank', badge: true },
  { id: 'canara-bank', file: 'canara-bank.svg', alt: 'Canara Bank', badge: true },
  { id: 'rbl-bank', file: 'rbl-bank.svg', alt: 'RBL Bank', badge: true },
  { id: 'sbi', file: 'sbi.svg', alt: 'State Bank of India' },
  { id: 'icici-bank', file: 'icici-bank.svg', alt: 'ICICI Bank' },
  { id: 'hdfc-bank', file: 'hdfc-bank.svg', alt: 'HDFC Bank' }
];

const MOROCCO_PARTNERS: IHomePartnerLogo[] = [
  { id: 'wafacash', file: 'wafacash.svg', alt: 'Wafacash', badge: true },
  { id: 'barid-cash', file: 'barid-cash.webp', alt: 'Barid Cash', badge: true },
  { id: 'al-barid-bank', file: 'al-barid-bank.svg', alt: 'Al Barid Bank', badge: true },
  { id: 'cih', file: 'cih.svg', alt: 'CIH', badge: true },
  { id: 'chaabi-cash', file: 'chaabi-cash.svg', alt: 'Chaabi Cash', badge: true },
  { id: 'cash-plus', file: 'cash-plus.svg', alt: 'Cash Plus', badge: true },
  { id: 'dirham-express', file: 'dirham-express.svg', alt: 'Dirham Express', badge: true }
];

const MEXICO_PARTNERS: IHomePartnerLogo[] = [
  { id: 'banco-azteca', file: 'banco-azteca.webp', alt: 'Banco Azteca', badge: true },
  { id: 'bbva-bancomer', file: 'bbva-bancomer.svg', alt: 'BBVA Bancomer', badge: true },
  { id: 'walmart', file: 'walmart.svg', alt: 'Walmart', badge: true },
  { id: 'bancoppel', file: 'bancoppel.webp', alt: 'BanCoppel', badge: true },
  { id: 'banorte', file: 'banorte.svg', alt: 'Banorte', badge: true },
  { id: 'elektra', file: 'elektra.svg', alt: 'Elektra', badge: true },
  { id: 'oxxo', file: 'oxxo.svg', alt: 'OXXO', badge: true }
];

const PERU_PARTNERS: IHomePartnerLogo[] = [
  { id: 'yape', file: 'yape.svg', alt: 'Yape', badge: true },
  { id: 'bcp', file: 'bcp.svg', alt: 'Banco de Crédito del Perú', badge: true },
  { id: 'interbank', file: 'interbank.svg', alt: 'Interbank', badge: true },
  { id: 'argenper', file: 'argenper.svg', alt: 'Argenper', badge: true },
  { id: 'perucourier-jet', file: 'perucourier-jet.svg', alt: 'Perucourier-Jet', badge: true },
  { id: 'dlocal', file: 'dlocal.svg', alt: 'Dlocal' },
  { id: 'peru-express', file: 'peru-express.svg', alt: 'Peru Express', badge: true }
];

const PHILIPPINES_PARTNERS: IHomePartnerLogo[] = [
  { id: 'gcash', file: 'gcash.svg', alt: 'GCash' },
  { id: 'bdo', file: 'bdo.svg', alt: 'BDO', badge: true },
  { id: 'metrobank', file: 'metrobank.svg', alt: 'Metrobank' },
  { id: 'palawan', file: 'palawan.webp', alt: 'Palawan Pawnshop' },
  { id: 'm-lhuillier', file: 'm-lhuillier.svg', alt: 'M Lhuillier' },
  { id: 'cebuana-lhuillier', file: 'cebuana-lhuillier.svg', alt: 'Cebuana Lhuillier', badge: true },
  { id: 'paymaya', file: 'paymaya.svg', alt: 'Maya', badge: true }
];

const SENEGAL_PARTNERS: IHomePartnerLogo[] = [
  { id: 'wave', file: 'wave.webp', alt: 'Wave', badge: true },
  { id: 'orange-money', file: 'orange-money.webp', alt: 'Orange Money', badge: true },
  { id: 'bridge-bank', file: 'bridge-bank.svg', alt: 'Bridge Bank Group', badge: true },
  { id: 'banque-habitat-senegal', file: 'banque-habitat-senegal.svg', alt: 'Banque de l\'Habitat du Sénégal', badge: true },
  { id: 'banque-islamique-senegal', file: 'banque-islamique-senegal.svg', alt: 'Banque Islamique du Sénégal', badge: true },
  { id: 'ecobank', file: 'ecobank.svg', alt: 'Ecobank Senegal', badge: true },
  { id: 'banque-atlantique', file: 'banque-atlantique.svg', alt: 'Banque Atlantique Senegal', badge: true }
];

export const HOME_PARTNERS_BY_ISO: { [iso: string]: IHomePartnerLogo[] } = {
  AF: AFGHANISTAN_PARTNERS,
  CO: COLOMBIA_PARTNERS,
  IN: INDIA_PARTNERS,
  MA: MOROCCO_PARTNERS,
  MX: MEXICO_PARTNERS,
  PE: PERU_PARTNERS,
  PH: PHILIPPINES_PARTNERS,
  SN: SENEGAL_PARTNERS
};



// WEBPACK FOOTER //
// ./src/model/types/home-revamp-partners.const.ts